module.exports = __webpack_public_path__ + "img/KSC03801.e1c88874.jpg";